"Sahi Bukhari Class";

import React, { useState, useEffect } from "react";
import axios from 'axios';
import AWS from 'aws-sdk';
import { notification } from 'antd';
import AudioPlayer from '../AudioPlayer';

const SahiBukhari = () => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedOption, setSelectedOption] = useState('option2');
    const [audioUrl, setAudioUrl] = useState('');
    const [audioUrlload, setaudioUrlload] = useState(false);
    const [currentLectureName, setCurrentLectureName] = useState('');
    const [search, setSearch] = useState("");
    const [deletingIds, setDeletingIds] = useState([]);
    const [activeLectureUrl, setActiveLectureUrl] = useState('');
    const [currentParts, setCurrentParts] = useState([]);
    const [currentPartIndex, setCurrentPartIndex] = useState(-1);

    const fetchData = async () => {
        try {
            const response = await axios.post('/api/getLecture', { type: "Sahi Bukhari Class" });
            setData(response.data.reverse());
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };

    const filteredData = data ? data.filter(item =>
        item.name.toLowerCase().includes(search.toLowerCase())
    ) : [];

    const handleOptionChange = (event) => {
        setData(data.reverse());
        setSelectedOption(event.target.value);
        console.log(event.target.value);
    };

    const handleLinkClick = (url, lectureName, originalUrl, parts, partIndex) => {
        setaudioUrlload(false);
        setActiveLectureUrl(originalUrl);
        if (parts) setCurrentParts(parts);
        if (partIndex !== undefined) setCurrentPartIndex(partIndex);
        const regex = /id=([^&]+)/;
        const idMatch = url.match(regex);
        console.log(idMatch);
        if (idMatch) {
            const id = idMatch[1];
            const s3 = new AWS.S3({
                endpoint: 's3.wasabisys.com',
                accessKeyId: 'I8ITVDL3GT2TQA0ZFSAB',
                secretAccessKey: 'DszVpDdzqP1si8PUybJQ3ae3784AJ1vTSN2sqRTq',
                region: 'us-east-1'
            });
            const params = {
                Bucket: 'sakeenat',
                Key: `${id}.mp4`,
                Expires: 60
            };
            s3.getSignedUrl('getObject', params, (err, url) => {
                if (err) {
                    notification.error({
                        message: "Unable to open this lecture",
                    });
                    console.log('error', err);
                } else {
                    setAudioUrl(url);
                    setCurrentLectureName(lectureName);
                    setaudioUrlload(true);
                }
            });
        }
    };

    const handleDeleteLecture = async (lecture) => {
        if (deletingIds.includes(lecture._id)) return;

        if (window.confirm(`Are you sure you want to delete "${lecture.name}"?`)) {
            setDeletingIds(prev => [...prev, lecture._id]);

            try {
                const response = await axios.post('/api/deleteLecture', lecture);

                if (response.data.success) {
                    notification.success({
                        message: "Lecture Deleted",
                        description: "The lecture and its files have been deleted successfully."
                    });
                    fetchData();
                } else {
                    notification.error({
                        message: "Delete Failed",
                        description: response.data.message || "Failed to delete the lecture."
                    });
                }
            } catch (error) {
                console.error("Error deleting lecture:", error);
                notification.error({
                    message: "Delete Failed",
                    description: "An error occurred while deleting the lecture."
                });
            } finally {
                setDeletingIds(prev => prev.filter(id => id !== lecture._id));
            }
        }
    };

    function removeSpecificPhrase(inputString, phraseToRemove) {
        const resultString = inputString.replace(new RegExp(phraseToRemove, 'g'), '');
        return resultString;
    }

    if (isLoading) {
        return (
            <div className="al-container">
                <div className="al-loading">
                    <div className="al-spinner" />
                    Loading lectures...
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="al-container">
                <div className="al-error">Failed to load lectures. Please try again.</div>
            </div>
        );
    }

    return (
        <div className="al-container">
            <div className="al-toolbar">
                <div className="al-toolbar-left">
                    <span className="al-lecture-count">{filteredData.length} lecture{filteredData.length !== 1 ? 's' : ''}</span>
                    <select className="al-sort" value={selectedOption} onChange={handleOptionChange}>
                        <option value="option1">Oldest first</option>
                        <option value="option2">Newest first</option>
                    </select>
                </div>
                <div className="al-search-wrapper">
                    <span className="al-search-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                        </svg>
                    </span>
                    <input
                        type="text"
                        className="al-search"
                        placeholder="Search in Sahi Bukhari..."
                        value={search}
                        onChange={handleSearchChange}
                    />
                </div>
            </div>

            <div className="al-list-header">
                <span>#</span>
                <span>Title</span>
                <span className="al-header-parts">Parts</span>
                <span></span>
            </div>

            <div className="al-list" style={{ marginBottom: audioUrl ? '100px' : '0' }}>
                {filteredData.length === 0 && (
                    <div className="al-empty">No lectures found.</div>
                )}
                {filteredData.map((cur, index) => {
                    const cleanName = removeSpecificPhrase(cur.name, "By: Aalima Nikhat Haider Aapa");
                    const isActive = currentLectureName === cleanName;
                    const isDeleting = deletingIds.includes(cur._id);

                    return (
                        <div key={cur['_id']} className={`al-row ${isActive ? 'al-row-active' : ''}`}>
                            <span className="al-col-num">{index + 1}</span>
                            <div className="al-col-title-group">
                                <span className="al-col-title" title={cleanName}>{cleanName}</span>
                                {cur.date && <span className="al-col-date">{cur.date}</span>}
                            </div>
                            <div className="al-col-parts">
                                {cur.lectures.map((i, r) => (
                                    <button
                                        key={r}
                                        className={`al-play-chip ${activeLectureUrl === i ? 'al-play-chip-active' : ''}`}
                                        onClick={() => handleLinkClick(i, cleanName, i, cur.lectures, r)}
                                    >
                                        <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>
                                        {r + 1}
                                    </button>
                                ))}
                            </div>
                            <span className="al-col-actions">
                                <button
                                    className={`al-delete-btn ${isDeleting ? 'al-deleting' : ''}`}
                                    onClick={() => handleDeleteLecture(cur)}
                                    title={isDeleting ? 'Deleting...' : 'Delete lecture'}
                                >
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
                                    </svg>
                                </button>
                            </span>
                        </div>
                    );
                })}
            </div>

            {audioUrl && (
                <AudioPlayer
                    src={audioUrl}
                    isLoading={!audioUrlload}
                    title={currentLectureName}
                    subtitle="Sahi Bukhari Class"
                    hasPrev={currentPartIndex > 0}
                    hasNext={currentPartIndex < currentParts.length - 1}
                    onPrev={() => {
                        if (currentPartIndex > 0) {
                            const prevUrl = currentParts[currentPartIndex - 1];
                            handleLinkClick(prevUrl, currentLectureName, prevUrl, currentParts, currentPartIndex - 1);
                        }
                    }}
                    onNext={() => {
                        if (currentPartIndex < currentParts.length - 1) {
                            const nextUrl = currentParts[currentPartIndex + 1];
                            handleLinkClick(nextUrl, currentLectureName, nextUrl, currentParts, currentPartIndex + 1);
                        }
                    }}
                />
            )}
        </div>
    );
};

export default SahiBukhari;
